(function() {
	'use strict';

	angular
		.module('as.groups')
		.controller('networksCtrl',networksCtrl)
		.directive('networkListSingleCategory', networkListSingleCategory);

	networksCtrl.$inject = ['$scope','$rootScope','asNetworkPref','dialogform','analytics','$stateParams','$timeout','profileFilling','$http','$state','$filter'];
	function networksCtrl($scope,$rootScope,asNetworkPref,dialogform,analytics,$stateParams,$timeout,profileFilling,$http,$state,$filter) {

		if(chk_restrictions_return(29) && chk_restrictions_return(30)){
			chk_restrictions(29, true, true);
			return;
		}

		//variables
		$scope.open_feedback_dialog = open_feedback_dialog;
		$scope.currentTime = Math.floor(Date.now()/1000);
		$scope.shortName={ 'shortName':$rootScope.app_data.data.short_name};
		
		$scope.suggestProfession="";
		var displayContent = {},
            apply_section_start, apply_top, application_section_start, application_top, h1h = 72,
            h2h = (($rootScope.app_data.same_com_log)?48:0),
            bcH = 160,
            moset = 60,
            offset = 12,
            undefinedheight=48,
            tabChangeBrkPoints = {},
            customHeaderAdjust = 0;
        tabChangeBrkPoints.gtbrk = [];
        tabChangeBrkPoints.lsbrk = [];

		//functions

		activate();
		function activate() {
			if(!$rootScope.featureEnabled('alumni_value_networks.show_in_otherPages.*')) {
				$state.go('inapp.noticeboard', {});
				return;
			}

			$timeout(function() {
                setupScrollSpy();
            }, 1000);

		}	

		function setupScrollSpy() {
			var topPos = document.getElementById('scroll').offsetTop;
		    var scrollSpyTabs = document.getElementsByClassName("asScrollSpy");
		    for (var i = 0; i < scrollSpyTabs.length; i++) {
		        var tabtop = scrollSpyTabs[i].getBoundingClientRect().top;
		        if (window.pageYOffset < (bcH - h2h - offset)) {
		            tabChangeBrkPoints.gtbrk[i] = {
		                scrollPos: h1h + h2h + moset + h2h + offset - window.pageYOffset + (tabtop - h1h - h2h - moset - bcH),
		                spyfor: scrollSpyTabs[i].getAttribute("spyfor"),
		                tabelement: document.getElementById(scrollSpyTabs[i].getAttribute("spyfor"))
		            };
		        } else {
		        }

		    }
		    if ($stateParams.go_to_professions == 'true') {
	            scrollTo(topPos,topPos);
            }
		}
		

		function open_feedback_dialog() {
			var form_id = $rootScope.appmeta.forms.networks_suggestion_form;
			var field_id = $rootScope.appmeta.form_fields.network_suggestion_form_name_field;
			var prefillData = {response:{}};
			prefillData.response[field_id] = {id:field_id, response:$scope.suggestProfession};
			
			dialogform.asform({
				form_id: form_id,
				prefillData:prefillData,
				callBack:function(){
					profileFilling.modal(
		                'work,current_city,skills',
		                function() {},
		                function() {},
		                {'title': $filter('asPortalLang')('Update_Prof_Heading',"Update your profile and help people connect with you better")}
		            );
				}
			});
		}	
	}

	function networkListSingleCategory() {
        var directive = {
            restrict: 'E',
            templateUrl: './templates/pages/groups/network_list_single_category.html',
            scope: {
                category: '=',
                limit: '@',
                stopFetch: '@',
                fid: '@'
            },
            controller: networkListSingleCategoryController,
        };
        return directive;
    }

    networkListSingleCategoryController.$inject = ['$scope','$rootScope','asNetworkPref','$http','$state','$filter','contentApprovalAccessMsg'];
	function networkListSingleCategoryController($scope,$rootScope,asNetworkPref,$http,$state,$filter,contentApprovalAccessMsg) {
		//variables
		$scope.info = {};
		$scope.networks = [];
		$scope.networkUsers=[];
        $scope.isData = false;
        $scope.lock = false;
        $scope.showLoader = true;
		$scope.members=$filter('asLingo')('265');
		$scope.member=$filter('asLingo')('264');

        var data = { 
				type: 1,
				user_list: false,
				stream: 1,
				limit: $scope.limit
			};
		
		//functions
		$scope.loadMore = function() {fetchProfessions()} ;
		$scope.onFollowClick = onFollowClick;
		$scope.fetchProfessions = fetchProfessions;
		$scope.viewAllClick = viewAllClick;
		
		activate();
		function activate() {
			//
		}

		function viewAllClick(id,event) {
			//ui-sref="inapp.single_network({fid:network.id})"
			if(chk_restrictions_return(29)){
				contentApprovalAccessMsg.showModel();
		        return;
			}
			else{
				$state.go('inapp.single_network',{fid:id});
			}
		}

		function onFollowClick(event, category, network){
			asNetworkPref.onFollowClick(event, category, network); 
		}
		function fetchProfessions(){
			$scope.showLoader = true;
			if($scope.isfetching)	return;

			$scope.isfetching = true;
			$http({
	        	url: './filters/dyn_filters_ctrl/get_list',
	        	method: 'POST',
	        	data: data
	    	}).success(function(response) {
	    		$scope.isfetching = false;
		        if (response.success==1) {
        			var fidArray=[];
        			var last_prof_members = 0;

		        	angular.forEach(response.data,function(value,key){
	        			$scope.networkUsers[value.id]=$scope.networks.length;
	        			if(angular.isDefined($scope.stopFetch) && $scope.stopFetch=="yes" && $scope.networks.length==data.limit)
	        				return;
		        		if(value.id != $scope.fid)
		        		{	
		        			$scope.networks = $scope.networks.concat(value);
		        			fidArray.push(value.id);
		        			last_prof_members = value.count;
		        		}
		        	});
		        	getUsers(fidArray);

		        	$scope.isData = true;
		        	data.stream++;
	    			if(response.data.length < data.limit) $scope.lock = true;
		        	$scope.showLoader = false;

        			// logic of professions listing
        			// - show all professions in which count is > 10
        			// - if total professions in which count>10 are less then 20 then load professions with count < 10 as well
        			// 
		        	if(last_prof_members<10 && $scope.networks.length>=20){
        				$scope.lock = true;
			        	$scope.showLoader = false;
			        	return;
        			}
	        	}
	        	else{
	        		$scope.lock = true;
	        		$scope.showLoader = false;
	        	}
	        	if(angular.isDefined($scope.stopFetch) && $scope.stopFetch=="yes"){
	        		if($scope.networks.length>=data.limit){
		        		$scope.lock = true;
		        		$scope.isfetching = true;
	        		}
	        	}
	    	});
		}

		function getUsers(fidArray){
			if(!fidArray)return;
			var data={fid:fidArray,stream:1,limit:3,simple_list: true};
			$scope.fetching = true;
			$http.post('./filters/dyn_filters_ctrl/getUserList',data)
			.then(function(res) {
				if(res && res.data && res.data.data  && res.data.success == 1 ) {
					angular.forEach(res.data.data,function(value,key){
						if($scope.networks[$scope.networkUsers[key]])
							$scope.networks[$scope.networkUsers[key]]['users']=value['users'];
					});
				}
				as_upgrade(100);
			});
		}
	}

})();